import React from 'react';
import { StubComponent } from 'site-modules/personalized-search/components/stub-component/stub-component';

export function Vin() {
  return <StubComponent />;
}
